import { render, staticRenderFns } from "./RetainedSample.vue?vue&type=template&id=aa35ffc8&scoped=true"
import script from "./RetainedSample.vue?vue&type=script&lang=js"
export * from "./RetainedSample.vue?vue&type=script&lang=js"
import style0 from "./RetainedSample.vue?vue&type=style&index=0&id=aa35ffc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35ffc8",
  null
  
)

export default component.exports